<div class="ais-ClearRefinements">
  <span class="{{state?.hasRefinements ? 'd-none': 'd-block m-2'}}">None</span>
  <button type="button" class="btn btn-link" [ngClass]="{'d-none': !state?.hasRefinements}" (click)="state.refine()"
    [disabled]="!state?.hasRefinements"> Clear
    All </button>
</div>
